<template>

  <div id="vy_body">
    <div id="vy_grid">
      <div id="vy_left_nav" class="p-4">
        <!--左サイドバー-->
        <ShakyoLeftbar/>
      </div>
      <div id="vy_main">
        <main>
          <h2 class="vy-kojin-title">{{ title }}</h2>

          <article style="padding: 0 10px;">

            <div id="manual_area">

                <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />HOME画面のマニュアル</span>
                <span v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

            </div>
            <br clear="all">

          <!--メインコンテンツ-->
          <hr>
              <table class="vy-form-table">
          
                  <!-- 社協名 -->
                  <tr >
                  <th>
                    <label for="shakyo_name">
                        社協名
                    </label>
                  </th>
                  <td style="text-align: left;">
                      {{ shakyo_list.shakyo_name }}（{{ shakyo_list.choson_code }}）
                      </td>
                  </tr>
                  <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                  <!-- ヘッダー -->

                  <tr >
                  <th>
                      <label for="header_logo">
                        事業のタイトルと実施者名

                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="min-width:600px">
                                PCの場合は「左側サイドバー」、スマートフォンの場合は「ヘッダー」に表示されます。<br>
                                ※ ロゴは、正方形の画像をご用意ください。
                                <div style="margin-left:17px">また、文字の長さによってはレイアウトが崩れる場合があります。</div>
                            </span>
                        </span>
                      </label>
                  </th>
                      <td style="">
                        
                        <!-- プレビュー -->
                        
                        <div style="
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        text-align: center;">
                            <img v-if="shakyo_list.header_logo" id="by-logo" v-bind:src="shakyo_list.header_logo" alt="ボラ活エール" style="width: 150px;height:150px" />
                            <img v-else id="by-logo" src="../../images/logo.png" alt="ボラ活エール"  />

                            <b :style="title_style1">{{ shakyo_list.header_title1 }}</b>
                            <b :style="title_style2">{{ shakyo_list.header_title2 }}</b>
                        </div>
                        <br>
                        
                        <div style="text-align: left;display: flex;align-items: center;margin:10px 0">
                       <div style="width:100px">ロゴ</div>
                        <input type='file' id="img_file" @change="imgUpload" accept="image/*"/>
                        </div>
                        <div style="text-align: left;display: flex;align-items: center;margin:10px 0">
                        
                       <div style="width:100px">事業のタイトル</div>
                        
                        <input type="text" class="form-control enter_forcus" id="header_title1" name="header_title1" 
                             v-model="shakyo_list.header_title1"  style="width:250px;margin-right:10px"/>
                         色：
                            <select @change="color_change1" class="form-select enter_forcus"
                                name="header_title_color1" id="header_title_color1" v-model="shakyo_list.header_title_color1" style="width: auto;float: left;" >
                                <option v-for:="i in color_list.length" v-bind:value="color_code_list[i-1]">{{ color_list[i-1]}}</option>
                            </select>   
                        </div>
                        <div style="text-align: left;display: flex;align-items: center;">
                            
                       <div style="width:100px">実施者名</div>
                        <input type="text" class="form-control enter_forcus" id="header_title2" name="header_title2" 
                             v-model="shakyo_list.header_title2"  style="width: 250px;margin-right:10px"/>
                         色：
                            <select @change="color_change2" class="form-select enter_forcus"
                                name="header_title_color2" id="header_title_color2" v-model="shakyo_list.header_title_color2" style="width: auto;float: left;" >
                                <option v-for:="i in color_list.length" v-bind:value="color_code_list[i-1]">{{ color_list[i-1]}}</option>
                            </select>   
                        </div>

                        
                      </td>

                  </tr>

                  <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                  <!-- 公開日 -->
                  <tr >
                  <th>
                      <label for="kokai_date">公開日
                      
                      <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon">
                                「体験プログラムの内容を公開する日」になります。<br><br>
                                チラシや会報誌などが世の中に出回る時期など、体験ユーザーに公開される日を目安として設定してください。
                            </span>
                        </span>
                    </label>
                  </th>
                      <td style="text-align: left; display: flex;">
                          <input type="date" class="form-control enter_forcus" id="kokai_date" name="kokai_date" 
                          v-model="shakyo_list.kokai_date" style="width: 150px;"/>

                          <input type="time" class="form-control enter_forcus" id="kokai_start" name="kokai_start" 
                             v-model="shakyo_list.kokai_start"  style="width: 115px;"/>
                      </td>
                  </tr>
                  <!-- 申込開始日 -->
                  <tr >
                    <th>
                        <label for="moshikomi_date">申込開始日
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon">
                                この日付より前に体験ユーザー側の画面にアクセスすると、体験プログラムの内容は表示されますが、お申し込みはできません。<br><br>
                                事業全体の「申込受付期間」が決まったら、その開始日を目安として設定してください。
                            </span>
                        </span>
                    </label>
                    </th>
                    <td style="text-align: left; display: flex;">
                          <input type="date" class="form-control enter_forcus" id="moshikomi_date" name="moshikomi_date" 
                          v-model="shakyo_list.moshikomi_date" style="width: 150px;"/>

                        <input type="time" class="form-control enter_forcus" id="moshikomi_start" name="moshikomi_start" 
                        v-model="shakyo_list.moshikomi_start"  style="width: 115px;"/>
                      </td>
                  </tr>
                  <!-- 受付〆切日 -->
                   <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>

                  <tr>
                    <th rowspan=2>
                        <label for="end_date">受付〆切日
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:600px">
                                事業全体で、一括で申し込みを締め切る場合は、<b><u>事業単位</u></b>を選んでください。<br>
                                プログラムごとに申し込み期限が変動する場合は、<b><u>プログラム単位</u></b>を選んでください。
                            </span>
                        </span>
                    </label>
                    </th>
                    
                    <td style="text-align: left;">

                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input" id="end_shubetsu1" name="end_shubetsu1" value=1 v-model="shakyo_list.end_shubetsu"/>
                            <label class="form-check-label" for="end_shubetsu1">事業単位</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input" id="end_shubetsu2" name="end_shubetsu2" value=2 v-model="shakyo_list.end_shubetsu"/>
                            <label class="form-check-label" for="end_shubetsu2">プログラム単位</label>
                        </div>
                      </td>
                
                </tr>

                <tr>
                    
                    <td style="text-align: left;">
                        <div style=" display: flex;">
                            <input type="date" class="form-control enter_forcus" id="end_date" name="end_date" 
                            v-model="shakyo_list.end_date" style="width: 150px;"/>

                            <input type="time" class="form-control enter_forcus" id="end_time" name="end_time" 
                            v-model="shakyo_list.end_time"  style="width: 115px;"/>
                        </div>
                    </td>
                </tr>


                  <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                   <!-- 学生以外の参加 -->

                  <tr>
                    <th>
                        <label for="sanka">学生以外の参加
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:650px">
                                ● 有の場合：体験ユーザーの「体験者区分」で「学生」「一般」を選択できるようになります。<br>
                                ● 無の場合：体験ユーザーの「体験者区分」が「学生」で固定になります。
                            </span>
                        </span></label>
                    </th>
                    <td>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="sanka1" name="sanka1" value=1 v-model="shakyo_list.sanka"/>
                        <label class="form-check-label" for="sanka1">有</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="sanka2" name="sanka2" value=2 v-model="shakyo_list.sanka"/>
                        <label class="form-check-label" for="sanka2">無</label>
                    </div>
                    </td>
                
                </tr>
                  <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                   <!-- 自動送信メールの実施 -->

                  <tr>
                    <th>
                        <label for="mail_shubetsu">自動送信メールの実施
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:550px">
                                変更すると「メール情報」の自動送信メールの実施がこちらの設定に統一されます。<br>
                            ※ 後から個別に変更することも可能です。
                            </span>
                        </span></label>
                    </th>
                    <td colspan=2>
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input" id="mail_shubetsu1" name="mail_shubetsu1" value=1 v-model="mail_shubetsu"/>
                            <label class="form-check-label" for="mail_shubetsu1">する</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input" id="mail_shubetsu2" name="mail_shubetsu2" value=2 v-model="mail_shubetsu"/>
                            <label class="form-check-label" for="mail_shubets2">しない</label>
                        </div>
                        <br>
                        <!--
                        <span style="color:red">
                            変更すると「メール情報」の自動送信メールの実施がこちらの設定に統一されます。<br>
                            ※ 後から個別に変更することも可能です。
                        </span>-->
                    </td>
                
                </tr>
                  <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                   <!-- ユーザー登録後アンケートの実施 -->

                  <tr>
                    <th>
                        <label for="enqete_shubetsu">ユーザー登録後アンケートの実施
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:600px">
                                ● 実施する場合：プロフィール登録後に、アンケートを取ることができます。<br>
                                <div style="color:red;padding-left:10px;padding-bottom:10px;">体験ユーザーは、アンケートに回答していただくまで、体験プログラムのお申し込みが出来ません。</div>
                                ● 実施しない場合：プロフィール登録後、アンケートの画面に移動せず、すぐお申し込みいただけるようになります。
                            </span>
                        </span></label>
                    </th>
                    <td>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="enqete_shubetsu1" name="enqete_shubetsu1" value=1 v-model="enqete_shubetsu"/>
                        <label class="form-check-label" for="enqete_shubetsu1">する</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="enqete_shubetsu2" name="enqete_shubetsu2" value=2 v-model="enqete_shubetsu"/>
                        <label class="form-check-label" for="enqete_shubetsu2">しない</label>
                    </div>
                    </td>
                
                </tr>
                  <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                   <!-- 体験申込の流れ -->
                  <tr>
                    <th>
                        <label for="flow">体験申込の流れ
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:800px">
                                ● パターン１：事前研修へ参加していることを確認できたら、体験プログラムを申し込めるようになります。
                                <div style="color:red;padding-left:10px;padding-bottom:10px;">参加が確認できるまで、体験プログラムの申し込みはできません。</div>
                                ● パターン２：事前研修と体験プログラムを同時に申し込みます（事前研修参加の確認は行いません）。
                                <div style="padding-left:10px">※ 事前研修を実施しない場合も、こちらを選択してください。</div>
                            </span>
                        </span></label>
                    </th>
                    <td colspan=2>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="flow1" name="flow1" value=1 v-model="taiken_flow"/>
                        <label class="form-check-label" for="flow1">パターン１</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="flow2" name="flow2" value=2 v-model="taiken_flow"/>
                        <label class="form-check-label" for="flow2">パターン２</label>
                    </div>
                    <!--
                    <br>
                    パターン１：事前研修申込 → 体験申込（事前研修参加確認後）<br>
                    パターン２：体験申込（事前研修同時申込） ※事前研修を実施しない場合も、こちらを選択してください。
                -->
                    </td>
                
                </tr>
                  
                <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>

                  <!-- 活動報告書 -->
                  <tr>
                    <th>
                        <label for="moshikomi_date">活動報告書の提出
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:600px">
                                報告書の提出・集計を別の方法で行う場合は、こちらを「不要」に設定してください。<br>
                                ※ 必要・不要にかかわらず、参加証明書の発行には報告書の提出が必要です。
                            </span>
                        </span></label>
                    </th>
                    <td>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="houkoku_radio1" name="houkoku_radio1" value=1 v-model="shakyo_list.houkoku_shubetsu"/>
                        <label class="form-check-label" for="houkoku_radio1">必要</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="houkoku_radio2" name="houkoku_radio2" value=2 v-model="shakyo_list.houkoku_shubetsu"/>
                        <label class="form-check-label" for="houkoku_radio2">不要</label>
                    </div>
                    </td>
                
                </tr>
                  
                  
                  <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>

                  <!-- 参加証明書の発行 -->
                  <tr>
                    <th>
                        <label for="moshikomi_date">参加証明書のダウンロード
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:650px">
                               参加証明書を、システムを利用せず別の手段で送付したり、証明書自体を用意しない場合は「不要」を設定してください。
                            </span>
                        </span></label>
                    </th>
                    <td>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="shomei_radio1" name="shomei_radio1" value=1 v-model="shakyo_list.shomeisho_shubetsu"/>
                        <label class="form-check-label" for="shomei_radio1">必要</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="shomei_radio2" name="shomei_radio2" value=2 v-model="shakyo_list.shomeisho_shubetsu"/>
                        <label class="form-check-label" for="shomei_radio2">不要</label>
                    </div>
                    </td>
                
                </tr>

                  <!-- 参加証明書のダウンロード回数（参加証明書の発行が「必要」の場合のみ表示） -->
                  <tr v-show="shakyo_list.shomeisho_shubetsu == 1">
                    <th>
                        <label for="shomeisho_count">ダウンロード回数
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:700px">
                                体験ユーザーは、設定した回数まで証明書をダウンロードできます（参加したプログラム毎の回数です）。
                            </span>
                        </span></label>
                    </th>
                    <td  colspan=2>
                        <div style="text-align: left;display: flex;align-items: center;">
                          <input type="number" style="width:80px;margin-right:10px" class="form-control" id="shomeisho_count" name="shomeisho_count" 
                          v-model="shakyo_list.shomeisho_count" min=1 /> 回 
                          <!--
                          <span style="color:red;padding-left:10px">
                            申込者は設定した回数まで証明書をダウンロードできます（参加したプログラム毎の回数です）。</span>-->
                          </div>
                      </td>
                </tr>
                
                <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                  <!-- 体験義務日数 -->
                  <tr>
                    <th>
                        <label for="taiken_nissu">体験義務日数
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:550px">
                                設定した日数以上の体験プログラム参加で、参加証明書の発行が可能となります。
                            </span>
                        </span></label>
                    </th>
                    <td  colspan=2>
                        <div style="text-align: left;display: flex;align-items: center;">
                          <input type="number" style="width:80px;margin-right:10px" class="form-control" id="taiken_nissu" name="taiken_nissu" 
                          v-model="shakyo_list.taiken_nissu" min=1 /> 日 
                          <!--
                          <span style="color:red;padding-left:10px">
                            設定した日数以上の体験参加で証明書の発行が可能となります。</span>
                            -->
                          </div>
                      </td>
                
                </tr>
                
                <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>

                  <!-- プログラム申込可能回数の実施 -->
                  <tr>
                    <th>
                        <label for="moshikomi_date">体験プログラム申込可能回数
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:750px">
                                体験ユーザーは、設定した数までプログラムを申し込むことができます（キャンセルしたプログラムを除く）。<br>
                                一人当たりの申込数を制限したい場合や、イタズラ防止にご利用ください。
                            </span>
                        </span></label>
                    </th>
                    <td>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="program_shubetsu1" name="program_shubetsu1" value=1 v-model="shakyo_list.program_shubetsu"/>
                        <label class="form-check-label" for="program_shubetsu1">利用する</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" id="program_shubetsu2" name="program_shubetsu2" value=2 v-model="shakyo_list.program_shubetsu"/>
                        <label class="form-check-label" for="program_shubetsu2">利用しない</label>
                    </div>
                    </td>
                
                </tr>

                  <!-- プログラム申込可能回数 -->
                  <tr v-show="shakyo_list.program_shubetsu == 1">
                    <th>
                        <label for="program_count">申し込み可能回数上限</label>
                    </th>
                    <td  colspan=2>
                        <div style="text-align: left;display: flex;align-items: center;">
                          <input type="number" style="width:80px;margin-right:10px" class="form-control" id="shomeisho_count" name="program_count" 
                          v-model="shakyo_list.program_count" min=1 /> 回
                          <!--
                          <span style="color:red;padding-left:10px">
                            申込者は設定した数までプログラムを申し込むことができます（キャンセルしたプログラムを除く）。</span>-->
                          </div>
                      </td>
                </tr>
                <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                  <!-- キャンセル可能回数 -->
                  <tr>
                    <th>
                        <label for="cancel_count">キャンセル可能回数
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:700px">
                                体験ユーザーは「マイページ」からプログラムをキャンセルすることができますが、その上限を設けることができます。<br>
                                ※「0」回に設定すると何回でもキャンセルできるようになります。
                            </span>
                        </span></label>
                    </th>
                    <td  colspan=2>
                        <div style="text-align: left;display: flex;align-items: center;">
                          <input type="number" style="width:80px;margin-right:10px" class="form-control" id="cancel_count" name="cancel_count" 
                          v-model="shakyo_list.cancel_count" min=0 /> 回
                          <!--
                          <span style="color:red;padding-left:10px">
                            申込者はこの回数以上にキャンセルすることはできません。<br>
                        「0」回に設定すると何回でもキャンセルできるようになります。</span>-->
                          </div>
                      </td>
                
                </tr>
                   <tr >
                      <td colspan=2><div class="vy-dotted"></div></td>
                  </tr>
                  <!-- プライバシーポリシーの登録 -->
                  <tr >
                  <th>
                      <label for="policy">プライバシーポリシーの登録
                        <span class="balloon_parent">
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon">
                                各社協様のホームページに掲載されている内容をそのままご入力ください。
                            </span>
                        </span></label>
                  </th>
                  <td style="text-align: left;" colspan="2">
                            <b>タイトル</b>
                            <input type="text" class="form-control" id="policy_title" name="policy_title" 
                                 v-model="shakyo_list.policy_title"  style="width:100%;"/>
                                 <br>
                        <b>本文</b>
                        <textarea style="width:100%;height:350px;" v-model="shakyo_list.policy" class="form-control"></textarea>
                        <br>
                        <b>フッター</b>
                        <textarea style="width:100%;height: 80px;text-align: right;" v-model="shakyo_list.policy_footer" class="form-control"></textarea>

                      </td>
                  </tr>
                 

              </table>

              <button v-on:click="Update_check()"  class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;" >保存</button>

          </article>

          <!--フッター-->
          <FooterArea v-on:call="call"/>
        </main>
      </div>
      <div id="vy_right_nav" class="p-4">
          <!--右サイドバー-->
          <ShakyoRightBar
          v-on:call="call"/>
      </div>
    </div>
  </div>
      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
            v-bind:message_text="message"
            v-bind:message_cat="message_cat"
            v-bind:message_flag="message_flag"
            @close_message="Close_message"
            @ok_message="OK_message"/>

</template>

<script setup>
/* eslint-disable */
  import ShakyoLeftbar from './ShakyoHomeLeftBar.vue'

  import ShakyoRightBar from './ShakyoRightBar.vue'
  import FooterArea from '../common/FooterArea.vue'
  import MessageModal from './ShakyoMessageModal.vue'
  
  import { GlobalData, login_check,logout,getUser_email } from '../js/userdata_shakyo.js'
  import { useRouter, useRoute } from 'vue-router'
  import { ref,shallowRef, watch, nextTick  } from 'vue'
  import axios from 'axios'
  const url = GlobalData.$API_URL
  const content = shallowRef('')
  const router = useRouter();
  const route = useRoute();
  login_check()
  let shakyo_list = ref({}) // 社協データ
  let mail_shubetsu = ref(1) // 自動送信メールの種別（変更があった場合は一括更新となるので別個に用意）
  let taiken_flow = ref(2) // 体験フローのパターン（変更があった場合は事前研修申込メールの実施状況変更となるので別個に用意）
  let enqete_shubetsu = ref(1) // ユーザー登録後アンケートのパターン（変更があった場合はアンケート提出メールの実施状況変更となるので別個に用意）

  let color_list = ["黒","赤","青","水色","緑"];
  let color_code_list = ["black","red","blue","rgb(0,102,255)","green"];
  
    let title_style1 = ref({"color":"black","font-size": "14px","margin":"15px 0 0"})
    let title_style2 = ref({"color":"black","font-size": "17px"})


  GlobalData.shakyo = route.params.shakyo
  //---------------- 社協英名から市区町村コードを取得
  axios.post(GlobalData.$API_URL+"Shakyo_read", 
          {shakyo:GlobalData.shakyo}
          ).then(response => {

          GlobalData.choson_code = response["data"].choson_code
          shakyo_list.value = response["data"]


            // 自動送信メールの種別（変更があった場合は一括更新となるので別個に用意）
            mail_shubetsu.value = shakyo_list.value.mail_shubetsu

            // 体験フローのパターン（変更があった場合は事前研修申込メールの実施状況変更となるので別個に用意）
            taiken_flow.value = shakyo_list.value.flow

            // ユーザー登録後アンケートのパターン（変更があった場合はアンケート提出メールの実施状況変更となるので別個に用意）
            enqete_shubetsu.value = shakyo_list.value.enqete_shubetsu

          // プレビュー部分の色変え
          color_change1()
          color_change2()

  }).catch(error => {
      
  })
  
  const displayStatus = ref(true) //子コンポーネントを再レンダリングさせるためのフラグ
  let param = {}
  let title = "HOME"

  /* メッセージを表示するモーダルウィンドウ */
  let message = ref("")//表示するメッセージ
  let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
  let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
  let message_flag = ref(false)//表示・非表示フラグ

  /* 表示する子コンポーネント関係の情報 */
  const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
  contentMessage.value = null // 表示する子コンポーネント

  let Update_check = function(){
    message.value = "保存しますか？";

    // 表示中のメール種別と更新前のメール種別が違う場合
    if(mail_shubetsu.value != shakyo_list.value.mail_shubetsu){
        message.value += "\n※「自動送信メールの実施」が変更されているため、メールの実施設定を一括変更します。"
    }
      message_cat.value = 1;
      message_flag.value = true;
      message_method.value = "update";
      contentMessage.value = MessageModal
  }

  /* その他の関数 */
      
  // メッセージを表示するウィンドウでOKを押された時
  let OK_message = function(){ 
      Close_message();//メッセージを表示するウィンドウを閉じる
          
      // message_methodの内容に応じてこちら（親コンポーネント）の関数を起動する
      if(message_method.value == "update"){
          // 保存しますか？→OK
          Send()
      
      }else if(message_method.value == "update_kanryo"){
          // 保存しました→OK
          location.reload()
      
      }

  }

  // メッセージを表示するウィンドウを閉じる
  let Close_message = function(){
      contentMessage.value = null
      message_flag.value = false;
  }

  // 更新する
  let Send = function() {
      
      if(shakyo_list.value.kokai_start == ""){
        shakyo_list.value.kokai_start = "00:00"
      }
      if(shakyo_list.value.moshikomi_start == ""){
        shakyo_list.value.moshikomi_start = "00:00"
      }
      if(shakyo_list.value.end_date == ""){
        shakyo_list.value.end_date = null
      }
      if(shakyo_list.value.end_time == ""){
        shakyo_list.value.end_time = "00:00"
      }
      // APIのURLを指定する
      let Set_URL = url + "Shakyo_update"
      let Set_result = {
          shakyo_code:shakyo_list.value.shakyo_code,
          policy:shakyo_list.value.policy,
          policy_title:shakyo_list.value.policy_title,
          policy_footer:shakyo_list.value.policy_footer,
          kokai_date:shakyo_list.value.kokai_date,
          kokai_start:shakyo_list.value.kokai_start,
          moshikomi_date:shakyo_list.value.moshikomi_date,
          moshikomi_start:shakyo_list.value.moshikomi_start,
          houkoku_shubetsu:shakyo_list.value.houkoku_shubetsu,
          shomeisho_shubetsu:shakyo_list.value.shomeisho_shubetsu,
          header_logo:shakyo_list.value.header_logo,
          header_title1:shakyo_list.value.header_title1,
          header_title2:shakyo_list.value.header_title2,
          header_title_color1:shakyo_list.value.header_title_color1,
          header_title_color2:shakyo_list.value.header_title_color2,
          flow:taiken_flow.value,// ここだけshakyo_list外の項目
          sanka:shakyo_list.value.sanka,
          end_shubetsu:shakyo_list.value.end_shubetsu,
          end_date:shakyo_list.value.end_date,
          end_time:shakyo_list.value.end_time,
          shomeisho_count:shakyo_list.value.shomeisho_count,
          mail_shubetsu:mail_shubetsu.value, // ここだけshakyo_list外の項目
          enqete_shubetsu:enqete_shubetsu.value,// ここだけshakyo_list外の項目
          taiken_nissu:shakyo_list.value.taiken_nissu,
          program_count:shakyo_list.value.program_count,
          program_shubetsu:shakyo_list.value.program_shubetsu,
          cancel_count:shakyo_list.value.cancel_count,
          update_user:GlobalData.$User_email,
      }

      // APIへ値を送信する
      axios.post(Set_URL,
          Set_result,
          GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
          .then(response => {
              //正常な結果が返ってきた場合の処理
              // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが削除できなかった等）。
              // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

              if(response.data["status"] == 1){

                message.value = "エラーが発生しました。\n"+response.data["message"];
                 message_method.value = "add_error";
                message_cat.value = 0;
                message_flag.value = true;
                contentMessage.value = MessageModal
              }else{
                // 表示中のメール種別と更新前のメール種別が違う場合
                if((mail_shubetsu.value != shakyo_list.value.mail_shubetsu)){
                    Mail_all_update()
                }else if((taiken_flow.value != shakyo_list.value.flow) || (enqete_shubetsu.value != shakyo_list.value.enqete_shubetsu)){
                    // 体験フローまたはユーザー登録後アンケートが変更されていた場合のみ
                    Mail_other_update()
                }else{
                    message.value = "更新が完了しました。";
                    message_method.value = "update_kanryo";
                    message_cat.value = 0;
                    message_flag.value = true;
                    contentMessage.value = MessageModal
                }
              }
          })
          .catch(error => {
            if(send_error_count == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "send_error";
                contentMessage.value = MessageModal
            }else{
                send_error_count++
                setTimeout(function(){Send()},"1000")
            }
          })

  }

  let all_update_error = 0
  // 自動送信メールの実施設定が変更された場合の対応
  let Mail_all_update = function(){

    // メール情報を全て取得する
        let set_url = url + "Mail_get_list"
        axios.post(set_url,
        {
            choson_code:GlobalData.choson_code,
            kubun:0
        },
        GlobalData.$ID_Token)  //市区町村コードを指定
        .then(response => {
            let results = response.data.mail;

            for(let m = 0;m<results.length;m++){
                let set_mail = results[m]
                let jisshi = true
                if(mail_shubetsu.value == 2){
                    jisshi = false
                }

                // メールの種類が７（事前研修申込時）
                if(set_mail.syurui == 7){
                    // 体験フローに変更があったとき
                    if(taiken_flow.value != shakyo_list.value.flow){
                        // 体験フロー１なら実施
                        if(taiken_flow.value == 1){
                            jisshi = true
                        }else{
                            jisshi = false
                        }
                    }
                }
                // メールの種類が８（アンケート提出時）
                if(set_mail.syurui == 8){
                    // ユーザー登録後アンケートに変更があったとき
                    if(enqete_shubetsu.value != shakyo_list.value.enqete_shubetsu){
                        // アンケート実施ならメールも実施
                        if(enqete_shubetsu.value == 1){
                            jisshi = true
                        }else{
                            jisshi = false
                        }
                    }
                }

                set_mail.jisshi = jisshi
                Mail_update(set_mail)

                if(m == (results.length-1)){
                    
                    message.value = "更新が完了しました。";
                    message_method.value = "update_kanryo";
                    message_cat.value = 0;
                    message_flag.value = true;
                    contentMessage.value = MessageModal
                }
            }

        })
        .catch(error => {
            if(all_update_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "get_error";
                contentMessage.value = MessageModal
            }else{
                all_update_error++
                setTimeout(function(){Mail_all_update()},"1000")
            }
        })

  }
  
  let other_update_error = 0
  // 体験フローかユーザー登録後アンケートによる変更があった場合
  let Mail_other_update = function(){

    // メール情報を全て取得する
    let set_url = url + "Mail_get_list"
    axios.post(set_url,
    {
        choson_code:GlobalData.choson_code,
        kubun:0
    },
    GlobalData.$ID_Token)  //市区町村コードを指定
    .then(response => {
        let results = response.data.mail;

        for(let m = 0;m<results.length;m++){
            let set_mail = results[m]

            // メールの種類が７（事前研修申込時）
            if(set_mail.syurui == 7){
                // 体験フローに変更があったとき
                if(taiken_flow.value != shakyo_list.value.flow){
                    // 体験フロー１なら実施
                    if(taiken_flow.value == 1){
                        set_mail.jisshi = true
                    }else{
                        set_mail.jisshi = false
                    }
                    Mail_update(set_mail)
                }
            }
            // メールの種類が８（アンケート提出時）
            else if(set_mail.syurui == 8){
                // ユーザー登録後アンケートに変更があったとき
                if(enqete_shubetsu.value != shakyo_list.value.enqete_shubetsu){
                    // アンケート実施ならメールも実施
                    if(enqete_shubetsu.value == 1){
                        set_mail.jisshi = true
                    }else{
                        set_mail.jisshi = false
                    }
                    
                    Mail_update(set_mail)
                }
                    
                message.value = "更新が完了しました。";
                message_method.value = "update_kanryo";
                message_cat.value = 0;
                message_flag.value = true;
                contentMessage.value = MessageModal
            }
        }
        
    })
    .catch(error => {
        if(other_update_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            other_update_error++
            setTimeout(function(){Mail_other_update()},"1000")
        }
    })

}

let kobetsu_update_error = 0

  // メール情報を更新
  let Mail_update = function(mail){
    let set_url = url + "Mail_update"
        axios.post(set_url,
        {
            mail_id:mail.mail_id,
            jisshi:mail.jisshi,
        },
        GlobalData.$ID_Token)  //市区町村コードを指定
        .then(response => {
            if(response.data["status"] == 1){

                message.value = "メール実施設定の更新でエラーが発生しました。\n"+response.data["message"];
                message_method.value = "add_error";
                message_cat.value = 0;
                message_flag.value = true;
                contentMessage.value = MessageModal
            }

        })
        .catch(error => {
                
            if(kobetsu_update_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "get_error";
                contentMessage.value = MessageModal
            }else{
                other_update_error++
                setTimeout(function(){Mail_update(mail)},"1000")
            }
        })
  }

// 「ファイルを選択」ボタン押下
let addimg = function(){
  const file_set = document.getElementById("img_file")
  file_set.click()
}

let error_count  = 0
// 画像ファイル取得
const imgUpload = (e) => {
    error_count  = 0
  const fileInput = e.target;
  const file = fileInput.files[0];

  let accept = file.name.split(".")[1]
  let file_name = GlobalData.shakyo+"_"+file.name.split(".")[0]+"."+accept
  upload(file, file_name, GlobalData.$ID_Token);
}


// ファイルアップロード
function upload (uploadedFile, filename, idtoken) {
    // PROVEDER_KEY作成
    let PROVIDER_KEY = 'cognito-idp.ap-northeast-1.amazonaws.com/' + GlobalData.$UserPoolId;
    AWS.config.region = 'ap-northeast-1';
    // IDプールにてIDトークンの認証を行う
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: GlobalData.$IdentityPoolId,
        Logins: {
            [PROVIDER_KEY]: idtoken.headers.Authorization,
        }
    });
    
        //資格情報のリフレッシュ処理
        AWS.config.credentials.refresh((err) => {
            if(err) {
                if(error_count == 5){
                    alert("画像ファイルのアップロードに失敗しました。" + err);
                }else{
                    error_count++
                    setTimeout(function(){upload(uploadedFile, filename, idtoken)},"1000")
                }
            }
        });
    
    // S3オブジェクト作成
    var s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: 'ap-northeast-1'
    });

    // パラメータ作成
    const params = {
      Bucket: GlobalData.$Image_bucket,
      Key: 'header/img/'+filename,
    }
    params.Body=uploadedFile;

    return new Promise((resolve, reject) => {
      // S3へオブジェクトをアップロード
      s3.putObject(params, (err, data) => {
        if (err) {
            if(error_count == 5){
                reject(err)
                alert("画像ファイルのアップロードに失敗しました。"+err)
            }else{
                error_count++
                setTimeout(function(){upload(uploadedFile, filename, idtoken)},"1000")
            }
        } else {
          resolve(data)
          shakyo_list.value.header_logo = "https://"+GlobalData.$Image_bucket+".s3-ap-northeast-1.amazonaws.com/header/img/"+filename
          //getImage(filename)

        }
      })
    })
}


let color_change1 = function(){
    title_style1.value["color"] = shakyo_list.value.header_title_color1
}

let color_change2 = function(){
    title_style2.value["color"] = shakyo_list.value.header_title_color2
}


  // HOME画面へ戻る
  let Return_home = function(){
      router.push('/'+GlobalData.shakyo+'/Kanri')
  } 
  
let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/HOME-173c0be34f8f8074bc1afa1725b3867d"
    window.open(url,"_blank")
}

let qanda_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/Q-A-177c0be34f8f80f08c74c585be043e05"
    window.open(url,"_blank")

}

  
  //-------------- URLが変わった時に対応する処理を起動するためのフック -----------------
  const wt = watch(route, () => {
      param = { cmd:route.params.cmd, id:route.params.id }
      call(param)
  })
  
  //-------------- URLに応じた処理のコンポーネントを呼び出す -------------------
  const call = function(proc) {
  
      switch(proc.cmd) {
          case 'open_taikensha':
              // 子コンポーネント側（ShakyoRightBar）からの命令でウィンドウを開く
              
                message_cat.value = 2;
                message_flag.value = true;
                contentMessage.value = MessageModal
              break
          default:
              break
      }
  }
</script>


<style scoped>
    table.vy-form-table th {
        width:35%
    }
</style>